import { colorsPalettes } from "@similarweb/styles";

export const colors = [
    colorsPalettes.midnight[300],
    colorsPalettes.orange[400],
    colorsPalettes.mint[400],
    colorsPalettes.solutions.SALES,
    colorsPalettes.solutions.DIGITAL_RESEARCH,
    colorsPalettes.purple[300],
    colorsPalettes.teal[300],
];
